import { RadioTile, TileGroup } from "@carbon/react";
import i18next from "../../../i18n";

type BiddingTypeSelectorProps = {
  types: any[];
  typeValue: any;
  onChangeType: (value: any) => void;
};

/**
 * Step 1: NORMAL vs INVERSE bidding-type choice, rendered as two selectable
 * Carbon cards (`TileGroup` + `RadioTile`) — one-or-the-other — replacing the
 * plain radio list. `onChangeType` still receives the full type object so
 * `Order.tsx#onSubmit` keeps reading `selectedType.value` unchanged.
 *
 * e2e note: each `RadioTile` still renders a real radio `<input id="bidding-type-{value}">`
 * with a `<label for=...>`, so the spec's `label[for="bidding-type-NORMAL"]` click and
 * `getByRole("radio").toBeChecked()` assertions keep working.
 */
const BiddingTypeSelector = ({
  types,
  typeValue,
  onChangeType,
}: BiddingTypeSelectorProps) => (
  <TileGroup
    name="bidding-type"
    className="order-bidding-type"
    legend={i18next.t("validations.tender.select")}
    valueSelected={typeValue?.value ?? ""}
    onChange={(value) =>
      onChangeType(types.find((type) => type.value === value) ?? null)
    }
  >
    {types.map((type) => (
      <RadioTile
        key={type.id}
        id={`bidding-type-${type.value}`}
        value={type.value}
        className="order-bidding-type__tile"
      >
        <span className="order-bidding-type__title">{type.title}</span>
        <span className="order-bidding-type__desc">{type.description}</span>
      </RadioTile>
    ))}
  </TileGroup>
);

export default BiddingTypeSelector;
